import React, { useState } from "react";
import { motion } from "framer-motion";
import Modal from "../ui/Modal";
import styles from "./css/settingLayout.module.css";
import { renderDefaultRow } from "../dashboard/TableRender";

const SettingLayout = ({
  heading,
  subheading,
  buttonText = "Create New",
  onAddClick,
  cardTitle,
  cardSubtitle,
  columns = [],
  table_data = [],
  data = [],
  renderRow,
  emptyMessage = "No data found.",
  isLoading = false,
  showModal = false,
  onCloseModal,
  modalTitle = "Authorization Required",
  modalBody,
}) => {
  const [copiedText, setCopiedText] = useState(null);
  // Support both 'data' and 'table_data' prop names
  const rowData = data.length > 0 ? data : table_data;

  const springFloatVariants = {
    hidden: { opacity: 0, y: 16 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1],
      },
    },
  };

  const levitateHover = {
    whileHover: {
      y: -2,
      boxShadow: "0 0 20px rgba(111, 230, 184, 0.06)",
    },
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentWrapper}>
        {/* Page Header */}
        <motion.div
          className={styles.pageHeader}
          initial="hidden"
          animate="visible"
          variants={springFloatVariants}
        >
          <div className={styles.titleGroup}>
            {heading && <h1 className={styles.pageTitle}>{heading}</h1>}
            {subheading && <p className={styles.pageSubtitle}>{subheading}</p>}
          </div>

          {onAddClick && (
            <button className={styles.btnAdd} onClick={onAddClick}>
              <i className="fas fa-plus"></i> {buttonText}
            </button>
          )}
        </motion.div>

        {/* Table Card */}
        <motion.div
          className={styles.tableCard}
          initial="hidden"
          animate="visible"
          variants={springFloatVariants}
          {...levitateHover}
        >
          {(cardTitle || cardSubtitle) && (
            <div className={styles.tableCardHeader}>
              <div>
                {cardTitle && <h5 className={styles.tableCardTitle}>{cardTitle}</h5>}
                {cardSubtitle && <p className={styles.tableCardSubtitle}>{cardSubtitle}</p>}
              </div>
            </div>
          )}

          <div className={styles.tableResponsive}>
            <table className={styles.customTable}>
              <thead>
                <tr>
                  {columns.map((col, idx) => (
                    <th key={col.key || idx}>{col.label}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {isLoading ? (
                  Array.from({ length: 3 }).map((_, idx) => (
                    <tr key={idx}>
                      {columns.map((_, cIdx) => (
                        <td key={cIdx}>
                          <span
                            style={{
                              background: "rgba(255,255,255,0.06)",
                              borderRadius: "4px",
                              height: "16px",
                              display: "inline-block",
                              width: "70%",
                            }}
                          ></span>
                        </td>
                      ))}
                    </tr>
                  ))
                ) : rowData.length === 0 ? (
                  <tr>
                    <td colSpan={columns.length || 1} className={styles.noTrxTd}>
                      <div className={styles.emptyIconWrapper}>
                        <i className="fas fa-inbox"></i>
                      </div>
                      <div>{emptyMessage}</div>
                    </td>
                  </tr>
                ) : (
                  rowData.map((item, index) => {
                    const globalRowIndex = index + 1;
                    if (renderRow) {
                      return renderRow(item, index, globalRowIndex, styles);
                    }
                    return renderDefaultRow(item, index, globalRowIndex, columns, {
                      styles,
                      copiedText,
                      setCopiedText,
                    });
                  })
                )}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>

      {/* Reusable Modal Component */}
      <Modal
        show={showModal}
        onClose={onCloseModal}
        title={modalTitle}
      >
        {modalBody}
      </Modal>
    </div>
  );
};

export default SettingLayout;
